// Lib
import { Action } from 'redux';

// Constants
import * as ACTIONS from './actionTypes';


export interface ActionGetUrlUpgradeAPI extends Action {
    dealerId: string
}


export const getUrlUpgradeAPI = (dealerId: string): ActionGetUrlUpgradeAPI => ({
    type: ACTIONS.GET_URLUPGRADE_API_REQUEST,
    dealerId
});
;


export interface ActionGetUrlUpgradeAPISuccess extends Action {
    url: string
}

export const getUrlUpgradeAPISuccess = (url: string): ActionGetUrlUpgradeAPISuccess => ({
    type: ACTIONS.GET_URLUPGRADE_API_SUCCESS,
    url
});

export const getUrlUpgradeAPIError = (error: any): Action & { error: any } => ({
    type: ACTIONS.GET_URLUPGRADE_API_ERROR,
    error
});




